import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ButtonsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
  flex-wrap: wrap;
`

export const ButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
